import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { 

  }
  /** 
   * Login function
   */

  authenticate(data: any): Observable<any> {
    return this.http.post(environment.baseUrl+'/auth', data);
  }

/** 
   * User Login function
   */

userLogin(data: any): Observable<any> {
  return this.http.post(environment.baseUrl+'/app/login/eps', data);
}

/**
   *Get shop list 
   * @returns 
   */
   getShopList() {
    return this.http.get(environment.baseUrl + '/login/get-shop-list');
  }


}
